import { useContext } from "react";
import { LocaleContext } from "../../providers/locale";
import get from "lodash/get";

/** Hook que gestiona la traducción en base a etiquetas */
export const useTranslation = () => {
  const localeContext = useContext(LocaleContext);

  const searchValue = (key) => {
    return get(localeContext?.activeResource, key);
  };

  const t = (key = "") => {
    const keyArray = key.split(".");
    const root = keyArray.shift();

    let result = searchValue(key);
    if (!result) {
      const parent = searchValue(`${root}.herencia`);
      result = ((parent && searchValue(`${parent}.${keyArray.join(".")}`)) || key);
    }
    return result;
  };

  return {
    t,
  };
};

export default useTranslation;